import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  error: undefined,
  result: undefined,
  isValid: false,
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.modulo.autofacturacion.info = {
      ...store.state.modulo.autofacturacion.info,
      ...data,
    };
  });
};

const setInfo = (store, data) => {
  store.setState((state) => {
    state.modulo.autofacturacion.info.data = {
      ...state.modulo.autofacturacion.info.data,
      ...data,
    };
  });
};

const detail = async (store, id, meta = {}) => {
  store.setState((state) => {
    state.modulo.autofacturacion.info.busy = true;
  });

  const params = {
    ...meta,
    include: 'tracking',
  };

  try {
    const response = await Http.get(`api/autofacturacion/tickets/${id}`, { params });

    store.setState((state) => {
      state.modulo.autofacturacion.info.busy = false;
      state.modulo.autofacturacion.info.data = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.autofacturacion.info.busy = false;
      state.modulo.autofacturacion.info.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.modulo.autofacturacion.info = { ...initialState };
  });
};

const resetError = (store) => {
  store.setState((state) => {
    state.modulo.autofacturacion.error = undefined;
  });
};

const AutofacturacionInfoStore = {
  state: () => initialState,
  actions: {
    setInfo,
    detail,
    reset,
    resetError,
    setPartialState,
  },
};

export default AutofacturacionInfoStore;
